import { render, staticRenderFns } from "./Sezione.vue?vue&type=template&id=31bc3fd7&scoped=true&"
import script from "./Sezione.vue?vue&type=script&lang=js&"
export * from "./Sezione.vue?vue&type=script&lang=js&"
import style0 from "./Sezione.vue?vue&type=style&index=0&id=31bc3fd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc3fd7",
  null
  
)

export default component.exports